export const SEO_CONTENT = {
  en: {
    home: {
      title: 'ME SupportNet - Supporting and connecting people with ME',
      description: 'ME SupportNet is an app for people with ME/CFS and long covid. Connect with local helpers, meet other patients, and discover ME-friendly events.',
      keywords: 'ME SupportNet, ME/CFS, Myalgic Encephalomyelitis, Chronic Fatigue Syndrome, ME app, ME support, local ME help, ME community, Long COVID, Post COVID, ME patients, ME awareness, ME resources, ME events, ME/CFS app',
      type: 'website' as const,
    },
    about: {
      title: 'About Us - ME SupportNet Team | ME SupportNet',
      description: 'ME SupportNet is an app for people with ME/CFS and long covid. Learn about the ME SupportNet team dedicated to supporting people with ME/CFS.',
      keywords: 'ME SupportNet team, ME/CFS support, ME community, ME awareness, ME help network, ME SupportNet mission, ME SupportNet vision',
      type: 'website' as const,
    },
    whatIsME: {
      title: 'What is ME? - Understanding Myalgic Encephalomyelitis | ME SupportNet',
      description: 'ME is a complex neuroimmunological illness that affects 71 million people worldwide.',
      keywords: 'what is ME, Myalgic Encephalomyelitis, ME/CFS, Chronic Fatigue Syndrome, ME symptoms, ME awareness, ME facts, ME information, ME disease, ME illness, neuroimmunological illness, post-exertional malaise, PEM, ME research, ME support, ME community, ME events, ME/CFS app',
      type: 'article' as const,
    },
    mitmachen: {
      title: 'Join Us - Support ME SupportNet | ME SupportNet',
      description: 'ME SupportNet is an app for people with ME/CFS and long covid. Join us to support the development of ME SupportNet.',
      keywords: 'join ME SupportNet, support ME SupportNet, ME SupportNet feedback, ME SupportNet beta testing, ME SupportNet development, ME SupportNet support',
      type: 'website' as const,
    },
    donate: {
      title: 'Donate - Support ME SupportNet Development | ME SupportNet',
      description: 'ME SupportNet is an app for people with ME/CFS and long covid. Your donation helps us bring ME SupportNet to those who need it most.',
      keywords: 'donate ME SupportNet, ME SupportNet donation, support ME SupportNet, ME SupportNet funding, ME app donation, ME SupportNet development support',
      type: 'website' as const,
    },
    impressum: {
      title: 'Legal Notice - ME SupportNet | Impressum',
      description: 'ME SupportNet is an app for people with ME/CFS and long covid. Legal information and contact details for the ME SupportNet website.',
      keywords: 'ME SupportNet legal notice, ME SupportNet impressum, ME SupportNet contact, legal information',
      type: 'website' as const,
    },
    privacy: {
      title: 'Privacy Policy - ME SupportNet | Data Protection',
      description: 'ME SupportNet is an app for people with ME/CFS and long covid. Privacy policy and data protection information for the ME SupportNet website.',
      keywords: 'ME SupportNet privacy policy, ME SupportNet data protection, ME SupportNet GDPR, ME SupportNet privacy',
      type: 'website' as const,
    },
    terms: {
      title: 'Terms of Service - ME SupportNet',
      description: 'Terms of Service for the ME SupportNet app, including community rules, safety guidance, reporting and the appeals procedure.',
      keywords: 'ME SupportNet terms of service, ME SupportNet terms, ME SupportNet community rules, ME SupportNet EULA',
      type: 'website' as const,
    },
    accountDeletion: {
      title: 'Delete Account and Data - ME SupportNet',
      description: 'How to delete your ME SupportNet account and all associated data — in the app or by request. Which data is deleted, which is retained and for how long.',
      keywords: 'ME SupportNet delete account, ME SupportNet data deletion, ME SupportNet account removal, delete my data, GDPR erasure',
      type: 'website' as const,
    },
    cookies: {
      title: 'Cookie Policy - ME SupportNet | Cookie Information',
      description: 'ME SupportNet is an app for people with ME/CFS and long covid. Information about cookies used on the ME SupportNet website and how to manage them.',
      keywords: 'ME SupportNet cookie policy, ME SupportNet cookies, cookie management, ME SupportNet cookie information',
      type: 'website' as const,
    },
  },
  de: {
    home: {
      title: 'ME SupportNet - Menschen mit ME unterstützen und verbinden',
      description: 'ME SupportNet ist eine App für Menschen mit ME/CFS und Long COVID. Verbinden Sie sich mit lokalen Helfenden, treffen Sie andere Betroffene und entdecken Sie ME-freundliche Veranstaltungen.',
      keywords: 'ME SupportNet, ME/CFS, Myalgische Enzephalomyelitis, Chronisches Erschöpfungssyndrom, ME App, ME Unterstützung, lokale ME Hilfe, ME Gemeinschaft, Long COVID, Post COVID, ME Betroffene, ME Aufklärung, ME Ressourcen, ME Veranstaltungen, ME/CFS App',
      type: 'website' as const,
    },
    about: {
      title: 'Über Uns - ME SupportNet Team | ME SupportNet',
      description: 'ME SupportNet ist eine App für Menschen mit ME/CFS und Long COVID. Lernen Sie das ME SupportNet Team kennen, das sich der Unterstützung von Menschen mit ME/CFS widmet.',
      keywords: 'ME SupportNet Team, ME/CFS Unterstützung, ME Gemeinschaft, ME Aufklärung, ME Hilfsnetzwerk, ME SupportNet Mission, ME SupportNet Vision',
      type: 'website' as const,
    },
    whatIsME: {
      title: 'Was ist ME? - Verständnis von Myalgischer Enzephalomyelitis | ME SupportNet',
      description: 'ME ist eine komplexe neuroimmunologische Erkrankung, die 71 Millionen Menschen weltweit betrifft.',
      keywords: 'was ist ME, Myalgische Enzephalomyelitis, ME/CFS, Chronisches Erschöpfungssyndrom, ME Symptome, ME Aufklärung, ME Fakten, ME Informationen, ME Krankheit, ME Erkrankung, neuroimmunologische Erkrankung, post-exertionale Verschlechterung, PEM, ME Forschung',
      type: 'article' as const,
    },
    mitmachen: {
      title: 'Mitmachen - ME SupportNet unterstützen | ME SupportNet',
      description: 'ME SupportNet ist eine App für Menschen mit ME/CFS und Long COVID. Helfen Sie uns, ME SupportNet zu denen zu bringen, die es am meisten brauchen.',
      keywords: 'ME SupportNet mitmachen, ME SupportNet unterstützen, ME SupportNet Feedback, ME SupportNet Beta-Testing, ME SupportNet Entwicklung, ME SupportNet Unterstützung',
      type: 'website' as const,
    },
    donate: {
      title: 'Spenden - ME SupportNet Entwicklung unterstützen | ME SupportNet',
      description: 'ME SupportNet ist eine App für Menschen mit ME/CFS und Long COVID. Ihre Spende hilft uns, ME SupportNet zu denen zu bringen, die es am meisten brauchen.',
      keywords: 'ME SupportNet spenden, ME SupportNet Spende, ME SupportNet unterstützen, ME SupportNet Finanzierung, ME App Spende, ME SupportNet Entwicklungsunterstützung',
      type: 'website' as const,
    },
    impressum: {
      title: 'Impressum - ME SupportNet | Rechtliche Informationen',
      description: 'ME SupportNet ist eine App für Menschen mit ME/CFS und Long COVID. Rechtliche Informationen und Kontaktdaten für die ME SupportNet Website.',
      keywords: 'ME SupportNet Impressum, ME SupportNet Kontakt, rechtliche Informationen, ME SupportNet rechtlich',
      type: 'website' as const,
    },
    privacy: {
      title: 'Datenschutzerklärung - ME SupportNet | Datenschutz',
      description: 'ME SupportNet ist eine App für Menschen mit ME/CFS und Long COVID. Datenschutzerklärung und Datenschutzinformationen für die ME SupportNet Website.',
      keywords: 'ME SupportNet Datenschutzerklärung, ME SupportNet Datenschutz, ME SupportNet DSGVO, ME SupportNet Datenschutz',
      type: 'website' as const,
    },
    terms: {
      title: 'Allgemeine Geschäftsbedingungen - ME SupportNet',
      description: 'Nutzungsbedingungen der ME SupportNet App, inklusive Community-Regeln, Sicherheitshinweisen, Meldeverfahren und Beschwerdeverfahren.',
      keywords: 'ME SupportNet AGB, ME SupportNet Nutzungsbedingungen, ME SupportNet Community-Regeln',
      type: 'website' as const,
    },
    accountDeletion: {
      title: 'Konto und Daten löschen - ME SupportNet',
      description: 'So löschen Sie Ihr ME SupportNet Konto und alle zugehörigen Daten — in der App oder auf Anfrage. Welche Daten gelöscht werden, welche bleiben und wie lange.',
      keywords: 'ME SupportNet Konto löschen, ME SupportNet Daten löschen, ME SupportNet Kontolöschung, Account löschen, DSGVO Löschung',
      type: 'website' as const,
    },
    cookies: {
      title: 'Cookie-Erklärung - ME SupportNet | Cookie-Informationen',
      description: 'ME SupportNet ist eine App für Menschen mit ME/CFS und Long COVID. Informationen über Cookies, die auf der ME SupportNet Website verwendet werden und wie man sie verwaltet.',
      keywords: 'ME SupportNet Cookie-Erklärung, ME SupportNet Cookies, Cookie-Verwaltung, ME SupportNet Cookie-Informationen',
      type: 'website' as const,
    },
  },
};

